import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Box, Typography } from "@material-ui/core";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  queueMenuContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    padding: theme.spacing(2),
    backgroundColor: "#f5f5f5",
    borderRadius: 8,
    border: `2px solid ${theme.palette.primary.main}`,
  },
  
  menuTitle: {
    fontSize: "12px",
    fontWeight: "bold",
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
    textTransform: "uppercase",
  },
  
  optionButton: {
    justifyContent: "flex-start",
    textTransform: "none",
    textAlign: "left",
    padding: theme.spacing(1.5, 2),
    fontSize: "14px",
    fontWeight: 500,
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.light}`,
    backgroundColor: "white",
    
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      color: "white",
      border: `1px solid ${theme.palette.primary.main}`,
    },
  },
  
  specialOption: {
    marginTop: theme.spacing(1),
    paddingTop: theme.spacing(1),
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  
  specialOptionButton: {
    fontSize: "12px",
    color: theme.palette.text.secondary,
    
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}));

/**
 * Renderiza opções de menu de fila como botões clicáveis
 * Detecta padrão: *[ codigo ]* - Label
 * 
 * @param {Array} options - [{code: "1", label: "Financeiro"}, ...]
 * @param {Function} onSelect - Callback quando usuário clica em opção
 * @param {String} title - Título do menu (opcional)
 */
export default function QueueMenuOptions({ options = [], onSelect, title }) {
  const classes = useStyles();
  
  if (!Array.isArray(options) || options.length === 0) {
    return null;
  }
  
  // Separar opções normais de opções especiais (# e !)
  const normalOptions = options.filter(
    (opt) => !["#", "!"].includes(String(opt.code).trim())
  );
  const specialOptions = options.filter(
    (opt) => ["#", "!"].includes(String(opt.code).trim())
  );
  
  const handleClick = (code) => {
    if (typeof onSelect === "function") {
      onSelect(String(code).trim());
    }
  };
  
  return (
    <Box className={classes.queueMenuContainer} role="region" aria-label="Queue menu options">
      {title && (
        <Typography className={classes.menuTitle}>
          {title}
        </Typography>
      )}
      
      {normalOptions.length > 0 && (
        <Box>
          {normalOptions.map((option, index) => (
            <Button
              key={`queue-option-${option.code}-${index}`}
              variant="outlined"
              color="primary"
              className={classes.optionButton}
              onClick={() => handleClick(option.code)}
              fullWidth
              aria-label={`Opção ${option.code}: ${option.label}`}
            >
              <strong>[{option.code}]</strong>
              <span style={{ marginLeft: 8 }}>{option.label}</span>
            </Button>
          ))}
        </Box>
      )}
      
      {specialOptions.length > 0 && (
        <Box className={classes.specialOption}>
          {specialOptions.map((option, index) => (
            <Button
              key={`queue-special-${option.code}-${index}`}
              variant="text"
              size="small"
              className={clsx(classes.optionButton, classes.specialOptionButton)}
              onClick={() => handleClick(option.code)}
              fullWidth
              aria-label={`Ação ${option.code}: ${option.label}`}
            >
              <strong>[{option.code}]</strong>
              <span style={{ marginLeft: 8 }}>{option.label}</span>
            </Button>
          ))}
        </Box>
      )}
    </Box>
  );
}
